import getScrollBarWidth from "./get-scroll-bar-width.util";
import toggleClass from "./toggle-class.util";

function handleHideScrollBar(loading) {
  if (loading) {
    const documentHeight = document.documentElement.scrollHeight;

    if (documentHeight <= window.innerHeight) return;

    toggleClass(document.body, "overflow-hidden", true);

    const scrollbarWidth = getScrollBarWidth();

    document.body.style.paddingRight = `${scrollbarWidth}px`;
  } else {
    toggleClass(document.body, "overflow-hidden", false);
    document.body.style.paddingRight = "";
  }
}

export default handleHideScrollBar;
